import * as React from 'react'

import clsx from 'clsx'

import NextImage from 'components/NextImage'
import Tag from 'components/Tag'
import { useEventContext } from 'context/EventContext'
import useViewport from 'hooks/useViewport'
import { ROUTE_NAMES } from 'routes'
import routeService from 'services/routes'

import Authors from './components/Authors'
import DateLabel from './components/DateLabel'

import classes from './Head.module.scss'

const mobileAspectRatio = {
  width: 640,
  height: 480,
}

const Head = ({ post, authorRef }) => {
  const authors = post.authors.items || []

  const { down, up } = useViewport()
  const eventContext = useEventContext({
    engagementComponent: 'author-pill',
  })

  const gotoAuthors = () => {
    if (!authorRef?.current) {
      return
    }
    window.scrollTo({
      top: authorRef.current.getBoundingClientRect().top - 100,
      behavior: 'smooth',
    })
  }
  return (
    <div className={clsx('Head', classes.root)}>
      <div className={classes.container}>
        <div
          className={clsx(classes.detailsContainer, { [classes.detailsContainerWithoutHeroImage]: !post.titleImage })}
        >
          {post.topic && (
            <Tag
              href={routeService.generatePath(ROUTE_NAMES.RESOURCES_TOPIC, { slug: post.topic.slug })}
              {...eventContext.addEvent({
                engagementDetails: 'chip_topic-link',
                engagementDestination: 'go-to_topics',
                engagementComponent: 'resources_topics',
                name: 'engagement_facet_click',
              })}
              className={classes.chip}
            >
              {post.topic.name}
            </Tag>
          )}
          <h1 className={classes.title}>{post.title}</h1>
          <div className={classes.details}>
            <DateLabel date={post.publishDate} />
          </div>
          <h2 className={classes.description}>{post.shortDescription}</h2>
          <div className={classes.authorsContainer}>
            {authors.length > 0 && (
              <Authors
                authors={authors}
                className={classes.authors}
                onClick={gotoAuthors}
                {...eventContext.addEvent({
                  name: 'engagement_facet_click',
                  engagementDetails: 'text-link_author-name',
                  engagementDestination: 'jump-to_author-card',
                })}
              />
            )}

            {down('sm') && post.titleImage && (
              <div className={classes.wrapperHeroImage}>
                <NextImage src={post.titleImage.url} alt={post.title} priority {...mobileAspectRatio} />
              </div>
            )}
          </div>
        </div>
        {up('md') && post.titleImage && (
          <div className={classes.wrapperHeroImage}>
            <NextImage src={post.titleImage.url} alt={post.title} priority {...mobileAspectRatio} />
          </div>
        )}
      </div>
    </div>
  )
}

export default Head
